var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#243665"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 29.5,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5998 34C28.5998 32.65 28.7208 31.6793 28.9628 31.088C29.2048 30.4967 29.7171 29.8507 30.4998 29.15C31.1831 28.55 31.7041 28.0293 32.0628 27.588C32.4215 27.1467 32.6005 26.6423 32.5998 26.075C32.5998 25.3917 32.3708 24.825 31.9128 24.375C31.4548 23.925 30.8171 23.7 29.9998 23.7C29.1498 23.7 28.5041 23.9583 28.0628 24.475C27.6215 24.9917 27.3088 25.5167 27.1248 26.05L24.5498 24.95C24.8998 23.8833 25.5415 22.9583 26.4748 22.175C27.4081 21.3917 28.5831 21 29.9998 21C31.7498 21 33.0958 21.4877 34.0378 22.463C34.9798 23.4383 35.4505 24.609 35.4498 25.975C35.4498 26.8083 35.2708 27.521 34.9128 28.113C34.5548 28.705 33.9921 29.3757 33.2248 30.125C32.4081 30.9083 31.9125 31.5043 31.7378 31.913C31.5631 32.3217 31.4755 33.0173 31.4748 34H28.5998ZM29.9998 40C29.4498 40 28.9791 39.8043 28.5878 39.413C28.1965 39.0217 28.0005 38.5507 27.9998 38C27.9991 37.4493 28.1951 36.9787 28.5878 36.588C28.9805 36.1973 29.4511 36.0013 29.9998 36C30.5485 35.9987 31.0195 36.1947 31.4128 36.588C31.8061 36.9813 32.0018 37.452 31.9998 38C31.9978 38.548 31.8021 39.019 31.4128 39.413C31.0235 39.807 30.5525 40.0027 29.9998 40Z",
    fill: "#243665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.404aa83cd15550c5ce57c61d2c41b548.svg";
export { ForwardRef as ReactComponent };